import React from "react";
import { Box, Typography } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { AccountHeaderTitle } from "../../components/AccountHeader";
import { useFallbackUrl } from "../../components/AppHistory";
import { Crumb } from "../../components/Breadcrumb";
import { PageComponent } from "../routes";
import { ActivityView } from "../../features/Activities/ActivityView";
import { SuccessNotification } from "../../features/Search/components/SuccessNotification";

export const ActivitiesPage: PageComponent<{}> = ({ fallbackUrl }) => {
  useFallbackUrl(fallbackUrl);
  const { accountNumber } = useParams();

  return (
    <>
      <Helmet>
        <title>{`${accountNumber} - Account Activity History`}</title>
      </Helmet>

      <AccountHeaderTitle>
        <Typography variant="h4" color="textPrimary">
          Activity history
        </Typography>
      </AccountHeaderTitle>

      {/* Breadcrumb */}
      <Crumb label="Activity History" />

      <Box px={3} py={3}>
        <SuccessNotification />
        <ActivityView />
      </Box>
    </>
  );
};
